import { create } from 'zustand';

import {
  applyListReport,
  buildAssistantContext,
  dropOtherRoutes,
  removeList,
  type AssistantContextShape,
  type ListContextEntries,
  type ListContextReport,
} from '../assistant/pageContext';

// Holds the assistant's live page context. Each list page reports its own selection and search
// state through useAssistantPageContext; readAssistantContext reads the whole map once per turn,
// outside React (pmpAssistantConfig is a module-level object, so getContext() cannot use a hook).

type PageContextStore = {
  lists: ListContextEntries;
  reportList: (entityType: string, report: ListContextReport) => void;
  clearList: (entityType: string) => void;
  /** Called on navigation: keeps only the lists belonging to the route the user is on now. */
  clearOtherRoutes: (pathname: string) => void;
};

export const usePageContextStore = create<PageContextStore>(set => ({
  lists: {},
  reportList: (entityType, report) => set(state => ({ lists: applyListReport(state.lists, entityType, report) })),
  clearList: entityType => set(state => ({ lists: removeList(state.lists, entityType) })),
  clearOtherRoutes: pathname => set(state => ({ lists: dropOtherRoutes(state.lists, pathname) })),
}));

/** The assistant's per-turn context, read outside React from the current location and store state. */
export const readAssistantContext = (): AssistantContextShape =>
  buildAssistantContext(usePageContextStore.getState().lists, globalThis.location.pathname);
